const MessageQuestion = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none">
      <path
        d="M12.6107 13.6435H9.72179L6.50789 15.7812C6.03122 16.099 5.38845 15.7596 5.38845 15.1818V13.6435C3.22179 13.6435 1.77734 12.199 1.77734 10.0324V5.699C1.77734 3.53234 3.22179 2.08789 5.38845 2.08789H12.6107C14.7773 2.08789 16.2218 3.53234 16.2218 5.699V10.0324C16.2218 12.199 14.7773 13.6435 12.6107 13.6435Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99965 8.53809V8.38645C8.99965 7.89534 9.303 7.63532 9.60634 7.42588C9.90245 7.22366 10.1985 6.96367 10.1985 6.487C10.1985 5.82256 9.6641 5.28809 8.99965 5.28809C8.33521 5.28809 7.80078 5.82256 7.80078 6.487"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.99458 10.2644H9.00108" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default MessageQuestion;
